/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-11-15 13:46:42
 * @LastEditors: linxi
 * @LastEditTime: 2025-09-12 10:04:52
 */
import { PlusOutlined, QuestionCircleTwoTone } from '@ant-design/icons'
import { unwrapResult } from '@reduxjs/toolkit'
import {
  Button,
  Col,
  Form,
  notification,
  Popover,
  Row,
  Select,
  Space,
  Switch,
  Tabs,
} from 'antd'
import React, { ReactElement, useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux'
import { RootDispatch } from '../../../../app/store'
import { EditableList } from '../../../../compnents/list/EditableList'
import { Columns } from '../../../composing/rankingList/columns'
import {
  AutomaticSchedulingDetailAsync,
  AutomaticSchedulingSettingAsync,
  deleteRankingList,
  editRankingListPage,
  getRankingListPage,
} from '../../../composing/composingSlice'
import styles from '../../functionSettingTabs.module.css'
import RankingModal from '../../../composing/rankingList/rankingModal'

export const ShiftSchedulingSettings = (props: {
  selectedTab?: any
}): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const [form] = Form.useForm()

  const [detail, setDetail] = useState<any>()

  const [buttonLoading, setButtonLoading] = useState(false) //排班弹窗是否显示

  const [isModalVisible, setIsModalVisible] = useState(false) //排班弹窗是否显示

  const [modaltitleType, setModaltitleType] = useState<number>(0) //排班弹窗标题

  const [tableLoading, setTableLoading] = useState(false) //表格loding

  const [tableInfo, setTableInfo] = useState() //排班弹窗标题

  const [params, setParams] = useState<any>({
    current: 1,
    size: 10,
  })

  const [page, setPage] = useState<any>({
    total: 0,
    items: [],
  })

  //获取班次列表数据
  const getPage = () => {
    setTableLoading(true)
    dispatch(getRankingListPage(params))
      .then(unwrapResult)
      .then((res) => {
        const data = {
          total: res.total,
          items: res,
        }
        setPage(data)
        setTableLoading(false)
      })
      .catch((err) => {
        setTableLoading(false)
      })
  }

  //获取自动排班设置并回填
  const getDetail = () => {
    dispatch(AutomaticSchedulingDetailAsync())
      .then(unwrapResult)
      .then((v: any) => {
        if (JSON.stringify(v) != '{}') {
          setDetail(v)
          form.setFieldsValue({
            day: v?.day,
            switchFlag: v?.switchFlag == 1 ? true : false,
          })
        } else {
          form.setFieldsValue({ switchFlag: 1 })
        }
      })
  }

  useEffect(() => {
    if (props?.selectedTab == '1') {
      getDetail()
      getPage()
    }
  }, [props?.selectedTab])

  return (
    <div className={styles.shiftSchedulingContent}>
      <Form
        form={form}
        autoComplete='off'
        onFinish={(v) => {
          // 保存自动排班设置的内容
          setButtonLoading(true)
          dispatch(
            AutomaticSchedulingSettingAsync({
              day: v?.day,
              switchFlag: v?.switchFlag ? 1 : 0,
              autoSettingId: detail?.id ? detail?.id : '',
            })
          )
            .then(unwrapResult)
            .then((val) => {
              notification.success({
                message: '设置成功',
              })
              form.resetFields()
              getDetail()
            })
            .finally(() => {
              setButtonLoading(false)
            })
        }}
      >
        <div style={{ overflow: 'auto', height: 'calc(100% - 40px)' }}>
          <Row style={{ display: 'flex' }}>
            <Col className={styles.titleLineHeight} style={{marginTop:'2px'}}>自动排班设置 :</Col>
            <Col style={{ flex: 1 }}>
              <Col span={24} className={styles.rowHeight}>
                <Form.Item name='switchFlag' valuePropName='checked'>
                  <Switch checkedChildren='开启' unCheckedChildren='关闭' />
                </Form.Item>
                <span className={styles.nameTips}>
                  开启后所有的状态为正常的医生、护士会按照机构营业时间排班
                </span>
              </Col>
              <Col span={24} className={styles.rowHeight}>
                <Form.Item
                  name='day'
                  label='排班时长'
                  required
                  rules={[
                    {
                      required: true,
                      message: '请选择排班时长',
                    },
                  ]}
                >
                  <Select
                    placeholder='时长选择'
                    allowClear
                    style={{ width: '100px' }}
                  >
                    <Select.Option value={7} key={7}>
                      7天
                    </Select.Option>
                    <Select.Option value={30} key={30}>
                      30天
                    </Select.Option>
                    <Select.Option value={90} key={90}>
                      90天
                    </Select.Option>
                    <Select.Option value={180} key={180}>
                      180天
                    </Select.Option>
                    <Select.Option value={360} key={360}>
                      360天
                    </Select.Option>
                  </Select>
                </Form.Item>
                <span className={styles.nameTips}>
                  设置排班时长后系统每天都会往后自动排一天，保证可预约的排班时长永远都是设置的天数
                </span>
              </Col>
            </Col>
          </Row>
          <Row style={{ display: 'flex' }}>
            <Col className={styles.titleLineHeight}>班次设置 :</Col>
            <Col style={{ flex: 1 }}>
              <Col span={24} className={styles.rowHeight}>
                <Button
                  size='middle'
                  type='primary'
                  icon={<PlusOutlined />}
                  onClick={() => {
                    setModaltitleType(1)
                    setIsModalVisible(true)
                  }}
                >
                  新增班次
                </Button>
              </Col>
              <Col span={23} className={styles.rowHeight}>
                <EditableList
                  style={{ flex: 1 }}
                  loading={tableLoading}
                  rowKey={(record: any) => record.rid}
                  page={{
                    current: params.current,
                    size: params.size,
                    total: page.total,
                    items: page.items,
                  }}
                  pagination={false}
                  columns={Columns(
                    params.size * (params.current - 1),
                    (action: any, t: any, btnText: string) => {
                      if (btnText == '删除') {
                        if (t.appointmentStatus == 1) {
                          //直接删除班次
                          dispatch(
                            deleteRankingList({
                              id: t.id,
                            })
                          )
                            .then(unwrapResult)
                            .then((res) => {
                              notification.success({ message: '删除成功' })
                              getPage()
                            })
                          return
                        } else {
                          setModaltitleType(3)
                        }
                      } else {
                        setModaltitleType(2)
                      }
                      setTableInfo(t)
                      setIsModalVisible(true)
                    }
                  )}
                />
              </Col>
            </Col>
          </Row>
        </div>
        <Row>
          <Col span={12}>
            <Button
              htmlType='button'
              onClick={() => {
                history.go(-1)
              }}
              style={{
                float: 'right',
                marginRight: '10px',
              }}
            >
              取消
            </Button>
          </Col>
          <Col span={12}>
            <Button
              loading={buttonLoading}
              type='primary'
              htmlType='submit'
              style={{
                float: 'left',
              }}
            >
              保存
            </Button>
          </Col>
        </Row>
      </Form>
      {/* 班次设置的新增编辑弹窗 */}
      <RankingModal
        title={modaltitleType}
        visible={isModalVisible}
        tableInfo={tableInfo}
        onOk={(obj) => {
          if (obj.textType == 3) {
            //删除
            //直接删除班次
            dispatch(
              deleteRankingList({
                id: obj.id,
              })
            )
              .then(unwrapResult)
              .then((res) => {
                setIsModalVisible(false)
                getPage()
                notification.success({ message: '删除成功' })
              })
            return
          } else {
            //新增/编辑
            dispatch(editRankingListPage(obj))
              .then(unwrapResult)
              .then((res) => {
                //新增编辑班次
                getPage()
                notification.success({
                  message: obj.id == null ? '新增成功' : '编辑成功',
                })
              })
          }
          setIsModalVisible(false)
        }}
        onCancel={() => {
          setIsModalVisible(false)
        }}
      />
    </div>
  )
}
